/**
 * ATLAS-700 Reporting - Clawback: Cls & Nvr Liv Accts vs Appvl Dt
 * Configuration settings for the report
 */
import _ from "lodash";
import moment from 'moment';
const config = (context) => {
    return {
        hideListHeader: true,
        hideActionColumn: true,
        editPath: "services",
        pageTitle: "Services",
        pageIcon: "work",
        listQueryId: "searchServices",
        deleteQueryId: "deleteService", //delete query
        linkRows: false,
        searchRecordsInput: false,
        columns: {
            portfolio: { label: "Portfolio", sortable: true },
            isRestructured: { label: "Restructured", sortable: true },
            account: { label: "Account", sortable: true },
            merchantNumber: { label: "Merchant Number", sortable: true },
            status: { label: "Status", sortable: true },
            approvalDate: { label: "Approval Date", sortable: true, dateFilter: true },
            dateFirstProcessing: { label: "Processing / Live Date", sortable: true, dateFilter: true },
            closeDate: { label: "Closed Date", sortable: true, dateFilter: true },
            closeReason: { label: "Reason for Closure", sortable: true },
            closeReasonDetails: { label: "Closed Merchant Reason Detail", sortable: true }
        },
        ignoreSortColumns: [
            "portfolio",
            "isRestructured",
            "account",
            "merchantNumber",
            "status",
            "approvalDate",
            "dateFirstProcessing",
            "closeDate",
            "closeReason",
            "closeReasonDetails"
        ],
        perPageOptions: [10, 20, 25, 50],
        defaults: {
            sort: "createdAt",
            sortDir: "desc",
            perPage: 10,
        },
        fuseSearch: null,
        formatResponse: (data) => {
            return context.formatResponse(data);
        },
    };
};

export default config;
